(function () {
  var ACTIVE = "is-active";

  function visibleVideo(videos) {
    for (var i = 0; i < videos.length; i++) {
      var wrap = videos[i].closest(".c-video__video");
      if (wrap && window.getComputedStyle(wrap).display !== "none") {
        return videos[i];
      }
    }
    return videos[0] || null;
  }

  function init(root) {
    if (!root || root.getAttribute("data-video-ready") === "true") return;

    var videos = root.querySelectorAll("[data-video]");
    var buttonWrap = root.querySelector("[data-mute-toggle]");
    var button = root.querySelector(".c-video__button");
    var progress = root.querySelector("[data-progress-bar]");
    if (!videos.length || !buttonWrap) return;

    root.setAttribute("data-video-ready", "true");

    function playVisible() {
      var current = visibleVideo(videos);
      videos.forEach(function (video) {
        if (video === current) {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function updateProgress() {
      var video = visibleVideo(videos);
      if (!video || !progress || !video.duration) return;
      var percent = (video.currentTime / video.duration) * 100;
      progress.style.width = percent + 6 + "%";
    }

    buttonWrap.addEventListener("click", function (event) {
      event.preventDefault();
      var video = visibleVideo(videos);
      if (!video) return;

      var muted = !video.muted;
      videos.forEach(function (item) {
        item.muted = muted;
      });
      buttonWrap.classList.toggle(ACTIVE, !muted);
      if (button) {
        button.setAttribute("aria-label", muted ? "Play Sound" : "Mute Sound");
      }
    });

    videos.forEach(function (video) {
      video.addEventListener("timeupdate", updateProgress);
    });

    playVisible();
    window.addEventListener("resize", playVisible);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll("[data-product-video]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
